var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircledArrowDown02 = function SvgCircledArrowDown02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    fill: "#FFF",
    d: "M14.3 6.5v12.1l-4.7-4.7L7 16.5l9 9 9-9-2.8-2.8-4.5 4.5V6.5zM16 0c8.8 0 16 7.2 16 16s-7.2 16-16 16S0 24.8 0 16 7.2 0 16 0"
  })));
};
export { SvgCircledArrowDown02 as ReactComponent };
export default __webpack_public_path__ + "assets/CircledArrow Down - 02.48b3b403628eda8905667a1d314caba0.svg";